import { LinksSchemaType } from "../type";

export const intlFlightLinksArray: LinksSchemaType = {
  main: "/inter-flights",
  maintitle: "همه پروازهای خارجی",
  mainImage: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/flight-int-desktop.png`,
  mainImageMobile: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/flight-int-mobile.png`,
  otherlinks: [
    {
      title: "پرواز تهران استانبول",
      href: "/inter-flights/THR_city/IST_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-istanbul.png`
    },
    {
      title: "پرواز استانبول تهران",
      href: "/inter-flights/IST_city/THR_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/istanbul-tehran.png`
    },
    {
      title: "پرواز تهران نجف",
      href: "/inter-flights/THR_city/NJF_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-najaf.png`
    },
    {
      title: "پرواز نجف تهران",
      href: "/inter-flights/NJF_city/THR_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/najaf-tehran.png`
    },
    {
      title: "پرواز تبریز استانبول",
      href: "/inter-flights/TBZ_city/IST_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tabriz-istanbul.png`
    },
    {
      title: "پرواز استانبول تبریز",
      href: "/inter-flights/IST_city/TBZ_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/istanbul-tabriz.png`
    },
    {
      title: "پرواز تهران مسقط",
      href: "/inter-flights/THR_city/MCT_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-masqat.png`
    },
    {
      title: "پرواز مسقط تهران ",
      href: "/inter-flights/MCT_city/THR_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/masqat-tehran.png`
    },
    {
      title: "پرواز تهران دبی",
      href: "/inter-flights/THR_city/DXB_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-dubai.png`
    },
    {
      title: "پرواز دبی تهران",
      href: "/inter-flights/DXB_city/THR_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/dubai-tehran.png`
    }
  ]
};
